import * as React from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import AddModal from "../Modals/AddModal";

import { Button } from "@mui/material";
import { formatDateStr } from "../../helper";
import Loading from "../../pages/Loading";

export default function OrgsTable({
  setOrgId,
  handleClickEdit,
  refresh,
  setRefresh,
  setAlertOpen,
  setAlertColour,
  setMessage,
}) {
  const [orgs, setOrgs] = React.useState([]);
  const [err, setErr] = React.useState(null);

  const [isLoading, setIsLoading] = React.useState(true);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 60,
      
    },
    {
      field: "client",
      headerName: "org",
      minWidth: 150,
      flex: 2,
      
    },
    {
      field: "expiry",
      headerName: "expiry",
      minWidth: 70,
      flex: 1,
    },
    {
      field: "used",
      headerName: "used",
      type: "number",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "remaining",
      headerName: "remaining",
      type: "number",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "keynum",
      headerName: "key",
      minWidth: 300,
      flex: 4,
    },

    {
      field: "action",
      
      disableColumnMenu: true,
      width: 84,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e) => {
          e.stopPropagation();
          setOrgId(params.row.id);
          handleClickEdit();
        };

        return (
          <Button size="small" variant="contained" onClick={onClick}>
            Edit
          </Button>
        );
      },
    },
  ];

  React.useEffect(() => {
    axios
      .get(`/orgs`)
      .then((res) => {
        const orgsFromApi = res.data.orgs;
        orgsFromApi.map((org) => {
          org.expiry = formatDateStr(org.expiry);
        });
        setOrgs(orgsFromApi);
        setIsLoading(false);
      })
      .catch((err) => {
        setErr(err.message);
      });
  }, [refresh]);

  return (
    <React.Fragment>
      {err ? (
        <p>{err}</p>
      ) : (
        <div
          id="m"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <Box sx={{ height: 660, width: "100%" ,   }}>
            <DataGrid
              loading={isLoading}
              scrollbarSize={1}
              rows={orgs}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
              
              experimentalFeatures={{ newEditingApi: true }}
              initialState={{
                sorting: {
                  sortModel: [{ field: "id", sort: "desc" }],
                },
              }}
            />
          </Box>
          <AddModal
            refresh={refresh}
            setRefresh={setRefresh}
            setAlertOpen={setAlertOpen}
            setAlertColour={setAlertColour}
            setMessage={setMessage}
          />
        </div>
      )}
    </React.Fragment>
  );
}
